export const PAYMENT_METHODS = [
  { value: "especes", label: "ESPECE", primary: true, button: "bg-white hover:bg-blue-50 text-blue-700 border-blue-600 border-2", badge: "bg-white text-blue-700 border border-blue-600", outline: "border-blue-300 text-blue-700 bg-white hover:bg-blue-50", print: { bg: "#ffffff", fg: "#1d4ed8", border: "#1d4ed8" } },
  { value: "wave", label: "WAVE", primary: true, button: "bg-sky-400 hover:bg-sky-500 text-white border-sky-400", badge: "bg-sky-400 text-white", outline: "border-sky-300 text-sky-700 bg-sky-50 hover:bg-sky-100", print: { bg: "#38bdf8", fg: "#ffffff", border: "#38bdf8" } },
  { value: "orange_money", label: "ORANGE MONEY", primary: true, button: "bg-orange-500 hover:bg-orange-600 text-black border-orange-500", badge: "bg-orange-500 text-black", outline: "border-orange-300 text-orange-800 bg-orange-50 hover:bg-orange-100", print: { bg: "#f97316", fg: "#000000", border: "#f97316" } },
  { value: "cheque", label: "Chèque", button: "bg-slate-700 hover:bg-slate-800 text-white border-slate-700", badge: "bg-slate-200 text-slate-700", outline: "border-slate-300 text-slate-700 bg-slate-50 hover:bg-slate-100" },
  { value: "banque", label: "Banque", button: "bg-indigo-600 hover:bg-indigo-700 text-white border-indigo-600", badge: "bg-indigo-100 text-indigo-700", outline: "border-indigo-300 text-indigo-700 bg-indigo-50 hover:bg-indigo-100" },
  { value: "avance", label: "Avance", button: "bg-teal-600 hover:bg-teal-700 text-white border-teal-600", badge: "bg-teal-100 text-teal-700", outline: "border-teal-300 text-teal-700 bg-teal-50 hover:bg-teal-100", saleOnly: true },
  { value: "non_paye", label: "NON PAYÉ", button: "bg-red-600 hover:bg-red-700 text-white border-red-600 border-2", badge: "bg-red-100 text-red-700", outline: "border-red-300 text-red-700 bg-red-50 hover:bg-red-100", saleOnly: true },
];

export const SETTLEMENT_METHODS = PAYMENT_METHODS.filter((m) => !m.saleOnly);

const byValue = Object.fromEntries(PAYMENT_METHODS.map((m) => [m.value, m]));

export const getPaymentMethodLabel = (method) => byValue[method]?.label || method;

export const paymentButtonClass = (method, selected = true) =>
  selected ? byValue[method]?.button || "bg-slate-900 text-white" : byValue[method]?.outline || "";

export const paymentBadgeClass = (method) => byValue[method]?.badge || "bg-slate-100 text-slate-700";

export const PaymentBadge = ({ method, className = "" }) => (
  <span className={`px-2 py-1 rounded-full text-xs font-medium ${paymentBadgeClass(method)} ${className}`} data-testid={`payment-badge-${method}`}>
    {getPaymentMethodLabel(method)}
  </span>
);

export const PRIMARY_METHODS = PAYMENT_METHODS.filter((m) => m.primary);

// Bandeau ESPECE | WAVE | ORANGE MONEY : le mode utilisé est plein, les autres en retrait (impression facture)
export const PaymentModeStrip = ({ method, size = "sm", className = "" }) => (
  <div className={`flex items-stretch gap-1 ${className}`} data-testid="payment-mode-strip">
    {PRIMARY_METHODS.map((m) => {
      const active = m.value === method;
      return (
        <div key={m.value} className={`flex-1 text-center font-bold uppercase tracking-wide rounded-sm ${size === "lg" ? "text-xs py-1.5" : "text-[10px] py-1"}`}
          style={{ background: active ? m.print.bg : "#ffffff", color: active ? m.print.fg : "#94a3b8", border: `2px solid ${active ? m.print.border : "#e2e8f0"}`, WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}
          data-testid={`payment-mode-${m.value}${active ? "-active" : ""}`}>
          {m.label}{active ? " ✓" : ""}
        </div>
      );
    })}
  </div>
);

// Rangée de modes alignés : NON PAYÉ | ESPECE | WAVE | ORANGE MONEY (+ autres en retrait)
export const PaymentModeButtons = ({ value, onChange, methods, testPrefix = "payment", disabled = false }) => {
  const main = [...methods.filter((m) => m.value === "non_paye"), ...methods.filter((m) => m.primary)];
  const rest = methods.filter((m) => m.value !== "non_paye" && !m.primary);
  return (
    <div className="space-y-2" data-testid={`${testPrefix}-mode-buttons`}>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid={`${testPrefix}-primary-row`}>
        {main.map((m) => {
          const active = value === m.value;
          return (
            <button key={m.value} type="button" disabled={disabled} onClick={() => onChange(m.value)}
              className={`h-10 rounded-md text-xs font-bold uppercase tracking-wide inline-flex items-center justify-center gap-1.5 transition-all ${paymentButtonClass(m.value, true)} ${active ? "ring-2 ring-offset-1 ring-slate-900 scale-[1.02]" : "opacity-70 hover:opacity-100"}`}
              aria-pressed={active} data-testid={`${testPrefix}-${m.value}`}>
              {m.icon && <m.icon className="w-3.5 h-3.5" />} {m.label}{active ? " ✓" : ""}
            </button>
          );
        })}
      </div>
      {rest.length > 0 && (
        <div className="flex flex-wrap gap-1.5" data-testid={`${testPrefix}-secondary-row`}>
          {rest.map((m) => (
            <button key={m.value} type="button" disabled={disabled} onClick={() => onChange(m.value)} className={`h-7 px-2.5 rounded-md text-[11px] font-medium border inline-flex items-center gap-1 ${value === m.value ? paymentButtonClass(m.value, true) + " ring-1 ring-slate-900" : paymentButtonClass(m.value, false)}`} aria-pressed={value === m.value} data-testid={`${testPrefix}-${m.value}`}>
              {m.icon && <m.icon className="w-3 h-3" />} {m.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
